<template>
  <footer>
    <div class="container">
      <div class="content has-text-centered">
        <p>© 2025 University of Fribourg. Licensed under the GNU AGPLv3. See https://www.gnu.org/licenses/. <a
            href="https://github.com/MM-AR/mmar"> <img src="https://img.shields.io/badge/GitHub-MM--AR%2Fmmar-blue"
              alt="GitHub Badge">
          </a></p>
      </div>
    </div>
  </footer>
</template>